import appState from './../../appState.js';
import createVtkVolumeAsync from './createVtkVolumeAsync.js'
import MPR from "@/utils/MPR/MPR.class";
export default async function(seriesNumber){
    let vtkVolume = MPR.vtkVolumes[seriesNumber];
    if(!vtkVolume){
        vtkVolume = await createVtkVolumeAsync(MPR.OriginalSeriesData.getDcmFilePath);
        // appState.vtkVolumes[seriesNumber] = vtkVolume;
        MPR.vtkVolumes = vtkVolume
    }
    return vtkVolume;
}